<template>
    <div>
        <el-row class="searchSection">
            <el-form ref="form" :inline="true" :model="searcheModel" class="external-form">
                <el-form-item label="录单时间">
                    <el-date-picker
                        size="small"
                        v-model="searcheModel.created_at"
                        type="daterange"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="财务审核">
                    <el-select size="small" v-model="searcheModel.finance_audit" placeholder="请选择">
                        <el-option label="不限" value=""></el-option>
                        <el-option label="通过" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="过滤销售额为0的订单">
                    <el-select size="small" v-model="searcheModel.not_have_amount" placeholder="请选择">
                        <el-option label="不限" value=""></el-option>
                        <el-option label="是" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="submitSearch" :loading="loading">搜索</el-button>
                    <el-button @click="resetForm()" size="small">重置</el-button>
                    <ExportFile 
                    v-if="Acs('/sale-analysis/' + activeName)"
                    :url="'/api/export/' + activeName" 
                    :params="searcheModel" 
                    filename="产品分析" 
                    buttonName="导出Excel">
                    </ExportFile>
                </el-form-item>
            </el-form>
        </el-row>
        <el-row class="searchSection">
            <el-col :span="2" :offset="18">
                <TableFields :path="$route.path" :tab="searcheModel.tab" :fields="fields" :key="count_config_key" @change="changeSearchFields"></TableFields>
            </el-col>
            <el-col :span="2" :offset="2">
                <CountConfig v-if="Acs('/count-config/view')" :path="$route.path" :tab="searcheModel.tab" :key="count_config_key"></CountConfig>
            </el-col>
        </el-row>
        <div class="main-bd mg20 pro-visible" v-loading="loading">
            <h3>公司产品分析</h3>
            <el-table 
            v-if="!loading"
            :data="list" 
            border 
            height="450"
            row-key="id" 
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
            :header-cell-style="{background: '#f3faff'}"
            :summary-method="getSummaries"
            show-summary
            key="1"
            >
            <template v-for="(item, index) in fields">
                <el-table-column :prop="item.prop" :label="item.label" v-if="checked_fields.includes(item.field)" v-bind="{ width: item.width, }" :key="index">
                    <template slot="header" v-if="item.content">
                        <span>{{item.label}}</span>
                        <el-tooltip class="item" effect="dark" :content="item.content" placement="top">
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleView(scope.row)" v-if="item.click">
                            {{ scope.row[item.field] }}
                        </el-button>
                        <span v-else>
                            {{ scope.row[item.field] }}
                        </span>
                    </template>
                </el-table-column>
            </template>
            <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="listView(scope.row)">详情</el-button>
                </template>
            </el-table-column>
            </el-table>
        </div>
        <div class="main-bd mg20 pro-visible" v-loading="order_loading">
            <h3>代理产品分析(统计代理单)</h3>
            <el-table 
            v-if="!order_loading"
            :data="order_list" 
            border 
            height="450"
            row-key="id" 
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
            :header-cell-style="{background: '#f3faff'}"
            :summary-method="getSummaries"
            show-summary
            key="2"
            >
            <template v-for="(item, index) in fields">
                <el-table-column :prop="item.prop" :label="item.label" v-if="checked_fields.includes(item.field)" v-bind="{ width: item.width }" :key="index">
                    <template slot="header" v-if="item.content">
                        <span>{{item.label}}</span>
                        <el-tooltip class="item" effect="dark" :content="item.content" placement="top">
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleView(scope.row)" v-if="item.click">
                            {{ scope.row[item.field] }}
                        </el-button>
                        <span v-else>
                            {{ scope.row[item.field] }}
                        </span>
                    </template>
                </el-table-column>
            </template>
            <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="listView(scope.row)">详情</el-button>
                </template>
            </el-table-column>
            </el-table>
        </div>
        <OrderListDialog v-if="dialogTableVisible" :params="params" @close="closeDialog"></OrderListDialog>
    </div>
  </template>
  <style scoped>
  </style>
  <script>
  import SaleanalysisCount from "~/services/saleanalysisCount";
  import UserCascader from "~/widgets/UserCascader.vue";
  import UserSelect from "~/widgets/UserSelect.vue";
  import Config from "~/config/params";
  import ExportFile from "~/widgets/ExportFile.vue";
  import CountConfig from "~/widgets/CountConfig.vue";
  import TableFields from "~/widgets/TableFields.vue";
  import OrderListDialog from "~/views/count/dialog/OrderListDialog.vue";
  export default {
  
    components: {
        UserCascader,
        UserSelect,
        Config,
        ExportFile,
        CountConfig,
        TableFields,
        OrderListDialog
    },
  
    props: {
        activeName: {
            type: String,
            default: ''
        }
    },
  
    data() {
        return {
            loading: false,
            list: [],
            searcheModel: {},
            searcheModel2: {},
            order_loading: false,
            order_list: [],
            count_config_key: 0,
            fields: [
                {field: 'name', label: '成交产品', width: 200},
                {field: 'total_amount', label: '销售额', prop: 'total_amount'},
                {field: 'amount_ratio', label: '销售额占比', content:'销售额占比=销售额/销售额总计', width: 110},
                {field: 'total_order', label: '订单数', prop: 'total_order'},
                {field: 'year_avg_price', label: '年均价', content:'年均价 = (销售额 / 合同年数) / 订单数', width: 90},
                {field: 'last_total_amount', label: '销售额同比', prop: 'last_total_amount', content:'上一年同一录单时间的产品价格总和', width: 110},
                {field: 'last_amount_ratio', label: '销售额同比占比', content:'销售同比占比=销售额同比/销售额同比总计', width: 140},
                {field: 'last_total_order', label: '订单数同比', prop: 'last_total_order'},
                {field: 'last_year_avg_price', label: '年均价同比', prop: 'last_year_avg_price', content:'上一年同一录单时间的年均价', width: 110},
                {field: 'sale_yoy', label: '销售额增长率', content:'销售额增长率 = (销售额-销售额同比) / 销售额同比', width: 130},
                {field: 'order_yoy', label: '订单数增长率', content:'订单数增长率 = (销售单数 - 销售单数同比) / 销售单数同比', width: 130},
                {field: 'year_avg_yoy', label: '年均价增长率', content:'均价增长率 = (年均价 - 年均价同比) / 年均价同比', width: 130},
            ],
            checked_fields: [],
            dialogTableVisible: false,
            params: {},
        };
    },
  
    mounted() {
        
    },
  
    created() {
        this.resetForm();
    },
  
    methods: {
        //重置按钮
        resetForm() {
            this.searcheModel = {
                created_at: Config.getDataTimes('this_week'),
                path: this.$route.path,
                tab: this.activeName,
                finance_audit: '',
                sign_mode: [0, 2],
                not_have_amount: ''
            };
            this.list = [];
            this.submitSearch();
        },
    
        // 筛选查询
        submitSearch() {
            let params = _.clone(this.searcheModel);
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            this.getList(params);
            this.searcheModel2 = _.clone(params);
            this.searcheModel2.sign_mode = [1];
            this.getProxyList(this.searcheModel2);
        },
    
        //获取列表
        getList(params) {
            // loading 动画
            this.loading = true;
            SaleanalysisCount.getList(params, this.activeName).then((res) => {
                if (res.code == 0) {
                    this.list = res.data;
                }
                this.loading = false;
            }).catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },

        //获取列表
        getProxyList(params) {
            // loading 动画
            this.order_loading = true;
            SaleanalysisCount.getList(params, this.activeName).then((res) => {
                if (res.code == 0) {
                    this.order_list = res.data;
                }
                this.order_loading = false;
            }).catch((err) => {
                console.error(err);
                this.order_loading = false;
            });
        },
    
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                // 第一列不计算合计，显示自定义的文字内容
                if (index === 0) {
                    sums.push('合计：' + data.length + '条');
                    return;
                }
                // 初始化合计值为0
                let sum = 0;
                // 遍历数据，累加顶级行的值
                data.forEach(item => {
                    // 累加当前项的值，注意转换为数字
                    sum += Number(item[column.property]);
                });
                // 如果所有值都是数字，则显示合计结果，否则显示'-'
                if (!isNaN(sum)) {
                    sums.push(Math.round(sum * 100) / 100); // 保留两位小数
                } else {
                    sums.push('--');
                }
            });
            return sums;
        },

        changeSearchFields(val){
            this.checked_fields = val;
        },

        listView(item){
            this.params = _.clone(this.searcheModel);
            this.params['product_id'] = item.product_id;
            if(item.hasOwnProperty('user_id')){
                this.params['user_id'] = item.user_id;
            }else if(item.hasOwnProperty('branch_id')){
                this.params['branch_id'] = item.branch_id;
            }
            this.dialogTableVisible = true;
        },

        closeDialog(){
            this.dialogTableVisible = false;
            this.params = [];
        },
    },
  };
  </script>


// WEBPACK FOOTER //
// src/views/count/table/productAnalysis.vue